<template>
  <v-data-table
          :headers="headers"
          :items="notifications"
          :items-per-page="10"
          :sort-by="['id']"
          sort-desc
  >
    <template v-slot:item.dispatch_time="{ item }">
      {{ formatDate(item.dispatch_time) }}
    </template>
    <template v-slot:item.reading_date="{ item }">
      {{ formatDate(item.reading_date) }}
    </template>
  </v-data-table>
</template>

<script>
import moment from "moment";
import { Notification } from '@/modules/notifications/Notification';

export default {
  name: 'UserNotifications',

  props: {
    notifications: {
      type: Array,
      required: true
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('NOTIFICATIONS.ITEM'),
          value: 'name'
        },
        {
          text: this.$t('NOTIFICATIONS.SENDING_TIME'),
          value: 'dispatch_time'
        },
        {
          text: this.$t('NOTIFICATIONS.DATE_TIME_OF_READING'),
          value: 'reading_date'
        }
      ];
    }
  },

  methods: {
    formatDate(data) {
      return Notification.formatDate(data);
    }
  }
};
</script>
